export function detalhesValidos(data, payload) {
  return Array.isArray(data) && Array.isArray(payload?.DETALHES)
    && data.length === payload.DETALHES.length
    && data.every((item) => item && /^[1-9]\d*$/.test(String(item.ID_ATENDIMENTO_DETALHE)));
}

export function itensTextosAtendimento(payload) {
  return (payload.TEXTOS || []).flatMap((exame, i) => (exame.TEXTOS || []).map((texto, j) => ({ chave: `${i}:${j}`, exame, texto })));
}

export function resultadoTextosValido(data, payload) {
  if(data?.contrato !== contratoAtendimento(payload) || data.ID_CLIENT_REQUEST !== payload.ID_CLIENT_REQUEST || !Array.isArray(data.textos)) { return false; }
  const esperados = itensTextosAtendimento(payload);
  return resultadoPrincipalValido(data, payload) && resultadoAnexosValido(data, payload) && resultadoCidsValido(data, payload) && resultadoComplementosValido(data, payload) && resultadoSolicitacoesValido(data, payload) && data.textos.length === esperados.length && new Set(data.textos.map(item => String(item?.ID_DIVERSOS))).size === esperados.length && new Set(data.textos.map(item => item?.CHAVE)).size === esperados.length &&
    esperados.every(({ chave, texto }) => {
      const item = data.textos.find(item => item?.CHAVE === chave);
      return item && /^[1-9]\d*$/.test(String(item.ID_DIVERSOS)) &&
        (!texto.ID_DIVERSOS || String(texto.ID_DIVERSOS) === String(item.ID_DIVERSOS));
    });
}

export function resultadoSolicitacoesValido(data, payload) {
  if(!payload.CONFIRMAR_SOLICITACOES_ATENDIMENTO) { return true; }
  const esperados = payload.SOLICITACOES || [];
  return data?.contrato === contratoAtendimento(payload) && data.ID_CLIENT_REQUEST === payload.ID_CLIENT_REQUEST &&
    Array.isArray(data.solicitacoes) && data.solicitacoes.length === esperados.length &&
    new Set(data.solicitacoes.map(item => String(item?.ID_SOLICITACAO_EXAME))).size === esperados.length &&
    new Set(data.solicitacoes.map(item => item?.CHAVE)).size === esperados.length &&
    esperados.every((solicitacao, i) => {
      const item = data.solicitacoes.find(item => item?.CHAVE === String(i));
      return item && /^[1-9]\d*$/.test(String(item.ID_SOLICITACAO_EXAME)) &&
        (!/^[1-9]\d*$/.test(String(solicitacao.ID)) || String(solicitacao.ID) === String(item.ID_SOLICITACAO_EXAME));
    });
}

export function resultadoComplementosValido(data, payload) {
  if(!payload.CONFIRMAR_HISTORICOS_RETORNOS) { return true; }
  return [["HISTORICOS", "historicos", "ID_ATENDIMENTO_HISTORICO"], ["RETORNOS", "retornos", "ID_AGENDA_RETORNO"]].every(([input, output, field]) => {
    const esperados = payload[input], recebidos = data?.[output];
    if(!Array.isArray(esperados) || !Array.isArray(recebidos) || recebidos.length !== esperados.length) { return false; }
    const ids = recebidos.filter(item => item?.[field] != null).map(item => String(item[field]));
    return new Set(ids).size === ids.length && new Set(recebidos.map(item => item?.CHAVE)).size === esperados.length && esperados.every((original, i) => {
      const item = recebidos.find(item => item?.CHAVE === String(i));
      return item && ["CONFIRMADO", "INDETERMINADO"].includes(item.ESTADO) &&
        (/^[1-9]\d*$/.test(String(item[field])) || (item[field] === null && item.ESTADO === "INDETERMINADO")) &&
        (!original[field] || String(original[field]) === String(item[field]));
    });
  });
}

export function respostaAtendimentoValida(data, payload) {
  if(!payload.CONFIRMAR_PRINCIPAL_ATENDIMENTO && !payload.CONFIRMAR_TEXTOS_ATENDIMENTO && !payload.CONFIRMAR_SOLICITACOES_ATENDIMENTO && !payload.CONFIRMAR_HISTORICOS_RETORNOS && !payload.CONFIRMAR_CIDS_ATENDIMENTO && !payload.CONFIRMAR_ANEXOS_ATENDIMENTO) { return detalhesValidos(data, payload); }
  return resultadoTextosValido(data, payload) && data.resultado === true && data.estado === "CONFIRMADO" &&
    data.geral === (payload.CONFIRMAR_PRINCIPAL_ATENDIMENTO ? "CONFIRMADO" : "CONCLUIDO_LEGADO") &&
    (!payload.CONFIRMAR_PRINCIPAL_ATENDIMENTO || data.principal.ESTADO === "CONFIRMADO") && detalhesValidos(data.detalhes, payload) &&
    data.textos.every(item => item.ESTADO === "CONFIRMADO") &&
    (!payload.CONFIRMAR_ANEXOS_ATENDIMENTO || data.anexos.every(item => item.ESTADO === "CONFIRMADO")) &&
    (!payload.CONFIRMAR_CIDS_ATENDIMENTO || data.cids.every(item => item.ESTADO === "CONFIRMADO")) &&
    (!payload.CONFIRMAR_HISTORICOS_RETORNOS || [...data.historicos, ...data.retornos].every(item => item.ESTADO === "CONFIRMADO")) &&
    (!payload.CONFIRMAR_SOLICITACOES_ATENDIMENTO || data.solicitacoes.every(item => item.ESTADO === "CONFIRMADO"));
}

export function erroGravacao(error) {
  const resposta = error?.response?.data;
  const falha = new Error(resposta?.mensagem || "Não foi possível confirmar a gravação. Confira o prontuário antes de tentar novamente.");
  falha.estado = resposta?.estado || error?.estado || "INDETERMINADO";
  falha.resposta = resposta;
  return falha;
}

export async function salvarDetalhesConfirmados(api, payload) {
  try {
    const { data } = await api.postOnce("atendimentos/access/salvarAtendimentoDetalhe",
      { ...payload, CONFIRMAR_GRAVACAO: true }, { timeout: 120000 });
    if(data?.resultado !== true || data?.estado !== "CONFIRMADO" || !detalhesValidos(data.detalhes, payload)) {
      throw Object.assign(new Error(), { response: { data } });
    }
    return data.detalhes;
  } catch(error) {
    throw erroGravacao(error);
  }
}

export function contratoAtendimento(payload) {
  if(payload.CONFIRMAR_PRINCIPAL_ATENDIMENTO) { return "ITENS_ATENDIMENTO_V6"; }
  if(payload.CONFIRMAR_ANEXOS_ATENDIMENTO) { return "ITENS_ATENDIMENTO_V5"; }
  if(payload.CONFIRMAR_CIDS_ATENDIMENTO) { return "ITENS_ATENDIMENTO_V4"; }
  return payload.CONFIRMAR_HISTORICOS_RETORNOS ? "ITENS_ATENDIMENTO_V3" : (payload.CONFIRMAR_SOLICITACOES_ATENDIMENTO ? "ITENS_ATENDIMENTO_V2" : "TEXTOS_ATENDIMENTO_V1");
}

export function itensCidsAtendimento(payload) {
  const vistos = new Set();
  return (payload.CID || []).flatMap((cid, i) => {
    if(String(cid.SELECIONADO) !== "1" || vistos.has(String(cid.ID_CID))) { return []; }
    vistos.add(String(cid.ID_CID)); return [{ chave: String(i), cid }];
  });
}

export function resultadoCidsValido(data, payload) {
  if(!payload.CONFIRMAR_CIDS_ATENDIMENTO) { return true; }
  if(!Array.isArray(payload.CID) || !Array.isArray(data?.cids)) { return false; }
  const esperados = itensCidsAtendimento(payload), recebidos = data.cids;
  const ids = recebidos.filter(item => item?.ID_ATENDIMENTOS_CID != null).map(item => String(item.ID_ATENDIMENTOS_CID));
  return recebidos.length === esperados.length && new Set(ids).size === ids.length &&
    new Set(recebidos.map(item => item?.CHAVE)).size === esperados.length && esperados.every(({ chave, cid }) => {
      const item = recebidos.find(item => item?.CHAVE === chave);
      const temArea = !!cid.AREA_ATENDIMENTO && String(cid.AREA_ATENDIMENTO) !== "0";
      if(!item || !["CONFIRMADO", "INDETERMINADO"].includes(item.ESTADO_CID) ||
        !(temArea ? ["CONFIRMADO", "INDETERMINADO"] : ["NAO_APLICAVEL"]).includes(item.ESTADO_AREA)) { return false; }
      const completo = item.ESTADO_CID === "CONFIRMADO" && item.ESTADO_AREA !== "INDETERMINADO";
      return item.ESTADO === (completo ? "CONFIRMADO" : "INDETERMINADO") &&
        (/^[1-9]\d*$/.test(String(item.ID_ATENDIMENTOS_CID)) || (item.ID_ATENDIMENTOS_CID === null && item.ESTADO_CID === "INDETERMINADO" && item.ESTADO_AREA !== "CONFIRMADO")) &&
        (!cid.ID_ATENDIMENTOS_CID || String(cid.ID_ATENDIMENTOS_CID) === String(item.ID_ATENDIMENTOS_CID));
    });
}

export function resultadoAnexosValido(data, payload) {
  if(!payload.CONFIRMAR_ANEXOS_ATENDIMENTO) { return true; }
  const esperados = payload.IMAGENS, recebidos = data?.anexos;
  return Array.isArray(esperados) && Array.isArray(recebidos) && recebidos.length === esperados.length &&
    new Set(recebidos.map(item => item?.CHAVE)).size === esperados.length && esperados.every((original, i) => {
      const item = recebidos.find(item => item?.CHAVE === String(i));
      if(!item || !["CONFIRMADO", "INDETERMINADO"].includes(item.ESTADO_REGISTRO) ||
        !["CONFIRMADO", "INDETERMINADO"].includes(item.ESTADO_ARQUIVO) ||
        !(original.idAprovacao || original.idDocumento ? ["CONFIRMADO", "INDETERMINADO"] : ["NAO_APLICAVEL"]).includes(item.ESTADO_ORIGEM)) { return false; }
      const completo = item.ESTADO_REGISTRO === "CONFIRMADO" && item.ESTADO_ARQUIVO === "CONFIRMADO" && item.ESTADO_ORIGEM !== "INDETERMINADO";
      return item.ESTADO === (completo ? "CONFIRMADO" : "INDETERMINADO") &&
        (/^[1-9]\d*$/.test(String(item.ID_PACIENTE_IMAGEM)) || (item.ID_PACIENTE_IMAGEM === null && item.ESTADO_REGISTRO === "INDETERMINADO")) &&
        (item.ESTADO_REGISTRO !== "CONFIRMADO" || (typeof item.ARQUIVO_TOKEN === "string" && item.ARQUIVO_TOKEN.length > 0)) &&
        (!original.ID_PACIENTE_IMAGEM || String(original.ID_PACIENTE_IMAGEM) === String(item.ID_PACIENTE_IMAGEM)) &&
        (item.AVISOS == null || (Array.isArray(item.AVISOS) && item.AVISOS.every(aviso => typeof aviso === "string")));
    });
}

export function resultadoPrincipalValido(data, payload) {
  if(!payload.CONFIRMAR_PRINCIPAL_ATENDIMENTO) { return true; }
  const principal = data?.principal, esperados = payload.DETALHES;
  const estadoValido = estado => ["CONFIRMADO", "INDETERMINADO"].includes(estado);
  if(!principal || String(principal.ID_ATENDIMENTO) !== String(payload.ID_ATENDIMENTO) ||
    !estadoValido(principal.ESTADO_CABECALHO) || !estadoValido(principal.ESTADO_REMOCOES) ||
    !Array.isArray(esperados) || !Array.isArray(principal.fichas) || principal.fichas.length !== esperados.length) { return false; }
  const ids = principal.fichas.filter(f => f?.ID_ATENDIMENTO_DETALHE != null).map(f => String(f.ID_ATENDIMENTO_DETALHE));
  if(new Set(ids).size !== ids.length || new Set(principal.fichas.map(f => f?.CHAVE)).size !== esperados.length ||
    !esperados.every((original, i) => {
      const ficha = principal.fichas.find(f => f?.CHAVE === String(i));
      return ficha && estadoValido(ficha.ESTADO) &&
        (/^[1-9]\d*$/.test(String(ficha.ID_ATENDIMENTO_DETALHE)) || (ficha.ID_ATENDIMENTO_DETALHE === null && ficha.ESTADO === "INDETERMINADO")) &&
        (!original.ID_ATENDIMENTO_DETALHE || String(original.ID_ATENDIMENTO_DETALHE) === String(ficha.ID_ATENDIMENTO_DETALHE) ||
          (ficha.ID_ATENDIMENTO_DETALHE === null && ficha.ESTADO === "INDETERMINADO"));
    })) { return false; }
  const completo = principal.ESTADO_CABECALHO === "CONFIRMADO" && principal.ESTADO_REMOCOES === "CONFIRMADO" && principal.fichas.every(f => f.ESTADO === "CONFIRMADO");
  return principal.ESTADO === (completo ? "CONFIRMADO" : "INDETERMINADO") && Array.isArray(data.detalhes) &&
    data.detalhes.length === principal.fichas.length && principal.fichas.every((f, i) =>
      data.detalhes[i]?.CHAVE === f.CHAVE && data.detalhes[i]?.ESTADO === f.ESTADO && data.detalhes[i]?.ID_ATENDIMENTO_DETALHE === f.ID_ATENDIMENTO_DETALHE);
}
